//
import React from 'react';
import { StyleSheet } from 'react-native';
import { Button, Dialog, Paragraph, Portal, Title } from 'react-native-paper';
import colors from '../../colors';
import { TXT_M, TXT_P, TXT_PP, MAX_WIDTH_MODAL } from '../../constants';
import CModal from './CModal';

type Props = {
  titulo: string;
  descricao: string;
  show: boolean;
  onClose: () => void;
  actions?: Array<{
    titulo: string;
    onPress?: () => void;
    color?: string;
    dark?: boolean;
  }>;
};

const AlertDialog: React.FC<Props> = (props) => {
  const { titulo, descricao, show, onClose, actions } = props;
  return (
    <CModal mostrarModal={show} onClose={onClose}>
      <Dialog.Content>
        <Title>{titulo}</Title>
        <Paragraph>{descricao}</Paragraph>
      </Dialog.Content>
      <Dialog.Actions style={{ justifyContent: 'space-around' }}>
        {actions &&
          actions.map((action, i) => (
            <Button
              key={'action' + i}
              onPress={() => {
                if (action.onPress) {
                  action.onPress();
                }
                onClose();
              }}
              mode={action.color ? 'contained' : 'text'}
              color={action.color}
              dark={action.dark}
            >
              {action.titulo}
            </Button>
          ))}

        {!actions && (
          <Button onPress={onClose} mode={'text'}>
            ok
          </Button>
        )}
      </Dialog.Actions>
    </CModal>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fff',
    width: '100%',

    marginBottom: 15
  },
  titulo: {
    fontSize: TXT_M,
    fontWeight: '500',
    color: colors.primary
  },
  tituloPreco: {
    fontSize: TXT_M,
    fontWeight: '500',
    color: colors.values
  },
  txtPergunta: {
    fontSize: TXT_P,
    fontWeight: '500'
  },
  txtResposta: {
    fontSize: TXT_PP,
    fontWeight: '500'
  },
  row: { flexDirection: 'row', flex: 1, justifyContent: 'space-between', alignItems: 'center' },
  value: { color: colors.values, fontSize: TXT_PP },
  viewActions: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    backgroundColor: colors.veryLightGrey,
    borderRadius: 5,
    marginBottom: 5
  },
  triangulo: {
    width: 0,
    height: 0,
    backgroundColor: 'transparent',
    borderStyle: 'solid',
    borderLeftWidth: 5,
    borderRightWidth: 5,
    borderBottomWidth: 7,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderBottomColor: colors.veryLightGrey,
    alignSelf: 'center'
  }
});

export default AlertDialog;
